import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { SpinnerService } from '../shared/loader/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private http: HttpClient,
    private spinner: SpinnerService,) { }

  public CommonApi(method, url, data): Observable<any> {
    this.showspinner();
    return this.http[method](`${environment.apiUrl}${url}`, data)
      .pipe(
        tap( // Log the result or error
          data => {
            setTimeout(() => {
              this.hidespinner()
            }, 500);
          },
          error => this.handleError(error)
        )
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.log(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    console.log('error', error)
    // Return an observable with a user-facing error message.

    setTimeout(() => {
      this.hidespinner()
    }, 500);

    return throwError({ message: error });
  };

  public setAppFavicon(icon: string) {
    this._document.getElementById('appFavicon').setAttribute('href', environment.apiUrl + icon);
    // this._document.getElementById('appFavicon').setAttribute('href', icon);
  }

  public setAppicon(icon: string) {
    this._document.querySelectorAll('.appicon').forEach(src => {
      src.removeAttribute('src');
    })
    setTimeout(() => {
      this._document.querySelectorAll('.appicon').forEach(src => {
        src.setAttribute('src', environment.apiUrl + icon);
      })
    }, 1000);
  }

  showspinner() {
    this.spinner.Spinner('show');
  }
  hidespinner() {
    this.spinner.Spinner('hide');
  }

}
